import { GenericSelectFilter } from '@app/core/list-view/base-filters/GenericSelectFilter';
import { GenericTextFilter } from '@app/core/list-view/base-filters/GenericTextFilter';
import { createFilter } from '@app/core/list-view/types';
import { FleetBalenaDeviceDto } from '@mi-front/api-v2';
import { parseAsString } from 'nuqs';
import { defineMessage } from 'react-intl';

/** Status filter values for Balena devices (local ListViewLocal filter). */
export type BalenaDeviceStatusFilter = 'online' | 'offline';

/**
 * Local filters for the Balena devices list (name + online/offline status + id).
 */
export const BALENA_DEVICES_FILTERS_CONFIG = [
  createFilter({
    name: 'name',
    label: defineMessage({
      id: 'fleet.devices.filters.name',
      defaultMessage: 'Nombre',
    }),
    parser: parseAsString.withDefault(''),
    isPermanent: true,
    component: GenericTextFilter,
    componentProps: {
      placeholder: defineMessage({
        id: 'fleet.devices.filters.namePlaceholder',
        defaultMessage: 'Buscar por nombre',
      }),
      sx: {
        width: '22ch',
      },
    },
    filterFn: (item, value) => {
      const device = item as FleetBalenaDeviceDto;
      const q = typeof value === 'string' ? value.trim().toLowerCase() : '';
      if (!q) {
        return true;
      }
      return device.name.toLowerCase().includes(q);
    },
  }),
  createFilter({
    name: 'status',
    label: defineMessage({
      id: 'fleet.devices.filters.status',
      defaultMessage: 'Estado',
    }),
    parser: parseAsString,
    isPermanent: true,
    component: GenericSelectFilter,
    componentProps: {
      options: [
        {
          value: 'online' satisfies BalenaDeviceStatusFilter,
          message: defineMessage({
            id: 'fleet.devices.status.online',
            defaultMessage: 'Online',
          }),
        },
        {
          value: 'offline' satisfies BalenaDeviceStatusFilter,
          message: defineMessage({
            id: 'fleet.devices.status.offline',
            defaultMessage: 'Offline',
          }),
        },
      ],
      sx: {
        minWidth: '14ch',
      },
    },
    filterFn: (item, value) => {
      const device = item as FleetBalenaDeviceDto;
      if (value === 'online') {
        return device.isOnline;
      }
      if (value === 'offline') {
        return !device.isOnline;
      }
      return true;
    },
  }),
  createFilter({
    name: 'id',
    label: defineMessage({
      id: 'fleet.devices.filters.id',
      defaultMessage: 'ID',
    }),
    parser: parseAsString.withDefault(''),
    isPermanent: true,
    component: GenericTextFilter,
    componentProps: {
      placeholder: defineMessage({
        id: 'fleet.devices.filters.idPlaceholder',
        defaultMessage: 'Buscar por ID',
      }),
      sx: {
        width: '14ch',
      },
    },
    filterFn: (item, value) => {
      const device = item as FleetBalenaDeviceDto;
      const q = typeof value === 'string' ? value.trim() : '';
      if (!q) {
        return true;
      }
      return String(device.id) === q;
    },
  }),
];
